const Endpoints = {
	login: '/auth/login/',
	logout: '/auth/logout/',
	project: (id: number) => `/project/${id}/`,
	projects: '/projects/',
	highscores: '/highscores/',
	test: '/test/',
} as const

export { Endpoints }
